import { render, staticRenderFns } from "./assurances.html?vue&type=template&id=daabcaf4&scoped=true&external"
import script from "./assurances.js?vue&type=script&lang=js&external"
export * from "./assurances.js?vue&type=script&lang=js&external"
import style0 from "./assurances.scss?vue&type=style&index=0&id=daabcaf4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daabcaf4",
  null
  
)

export default component.exports